(function () {
  "use strict";

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function gid(id) {
    return document.getElementById(id) || document.getElementById("pg-" + id);
  }

  function hashOf(href) {
    if (!href) return "";
    var i = href.indexOf("#");
    return i === -1 ? "" : href.slice(i + 1);
  }

  ready(function initGlgGuide() {
    var root = document.querySelector(".glg-guide, .pg-guide");
    if (!root) return;

    /* status: "live" = published article#chN in the page HTML (clickable + TOC).
       status: "soon" = not published yet — locked, no fake #ch2 anchors. */
    var CHAPTERS = [
      { n: "01", title: "What circular furniture means", href: "#ch1", status: "live", id: "ch1" },
      { n: "02", title: "Materials & certifications", href: "#ch2", status: "live", id: "ch2" },
      { n: "03", title: "Designing for disassembly", href: "#ch-upcoming", status: "soon" },
      { n: "04", title: "Furniture-as-a-Service & stewardship", href: "#ch-upcoming", status: "soon" },
      { n: "05", title: "Measuring carbon: Planet Price & EPDs", href: "#ch-upcoming", status: "soon" },
      { n: "06", title: "The defit & procurement playbook", href: "#ch-upcoming", status: "soon" }
    ];

    function unlockStickyAncestors() {
      var el = root.parentElement;
      while (el && el !== document.body && el !== document.documentElement) {
        el.style.setProperty("overflow", "visible", "important");
        el.style.setProperty("overflow-x", "visible", "important");
        el.style.setProperty("overflow-y", "visible", "important");
        el.style.setProperty("transform", "none", "important");
        el.style.setProperty("filter", "none", "important");
        el.style.setProperty("contain", "none", "important");
        el.style.setProperty("perspective", "none", "important");
        el = el.parentElement;
      }
    }

    function syncHeaderHeight() {
      var header =
        document.querySelector(".shopify-section-header") ||
        document.querySelector("header-component") ||
        document.querySelector("sticky-header") ||
        document.querySelector("[id*='shopify-section'][id*='header']") ||
        document.querySelector(".header-wrapper");
      var h = 92;
      if (header) {
        var r = header.getBoundingClientRect();
        h = Math.round(r.bottom > 0 ? r.bottom : r.height) || h;
        if (h < 40) h = Math.round(r.height) || 92;
      }
      root.style.setProperty("--header-h", h + "px");
      document.documentElement.style.setProperty("--glg-header-h", h + "px");
    }

    unlockStickyAncestors();
    syncHeaderHeight();
    window.addEventListener("resize", syncHeaderHeight, { passive: true });
    window.addEventListener("scroll", syncHeaderHeight, { passive: true });
    window.addEventListener("click", function () {
      setTimeout(syncHeaderHeight, 250);
    }, true);

    /* Mobile card tables: copy thead labels onto each td as data-th
       so CSS can show column names when thead is hidden. */
    function labelTableCells() {
      root.querySelectorAll(".table-wrap table").forEach(function (table) {
        var heads = Array.prototype.map.call(
          table.querySelectorAll("thead th"),
          function (th) {
            return (th.textContent || "").replace(/\s+/g, " ").trim();
          }
        );
        if (!heads.length) return;
        table.querySelectorAll("tbody tr").forEach(function (tr) {
          var cells = tr.querySelectorAll("th, td");
          Array.prototype.forEach.call(cells, function (cell, i) {
            if (cell.tagName === "TH") return;
            var label = heads[i] || "";
            if (label) cell.setAttribute("data-th", label);
          });
        });
      });
    }
    labelTableCells();

    function buildRail(target) {
      if (!target || target.children.length) return;
      CHAPTERS.forEach(function (ch) {
        var isLive = ch.status === "live" && ch.id && document.getElementById(ch.id);
        var li = document.createElement("li");
        li.className = "ch" + (isLive ? "" : " is-locked");
        if (ch.id) li.dataset.ch = ch.id;

        var head;
        if (isLive) {
          head = document.createElement("a");
          head.href = ch.href || ("#" + ch.id);
        } else {
          head = document.createElement("span");
        }
        head.className = "ch__head";
        head.innerHTML = '<span class="ch__num">' + ch.n + "</span><span>" + ch.title + "</span>";
        li.appendChild(head);

        /* Section TOC only for published chapters that exist in the DOM. */
        if (isLive) {
          var host = document.getElementById(ch.id);
          var subs = host ? host.querySelectorAll("[data-toc], .ch-section") : [];
          if (host && subs.length) {
            var ol = document.createElement("ol");
            ol.className = "ch__sections";
            subs.forEach(function (s) {
              if (!s.id) return;
              var sa = document.createElement("a");
              sa.href = "#" + s.id;
              sa.textContent = s.getAttribute("data-toc") || (s.querySelector("h3") ? s.querySelector("h3").textContent : s.id);
              sa.dataset.spy = s.id;
              var sli = document.createElement("li");
              sli.appendChild(sa);
              ol.appendChild(sli);
            });
            li.appendChild(ol);
          }
        }
        target.appendChild(li);
      });
    }

    buildRail(gid("railList"));
    buildRail(gid("railListMobile"));

    var spied = Array.prototype.slice.call(root.querySelectorAll("[data-toc], .ch-section"));

    function links() {
      return Array.prototype.slice.call(root.querySelectorAll("[data-spy], .ch__sections a"));
    }

    function chapterOf(el) {
      if (!el) return null;
      return el.classList.contains("chapter") ? el : el.closest(".chapter");
    }

    /* Map #ch2 (chapter article) → first section id so rail opens/highlights. */
    function resolveActiveId(id) {
      var el = id ? document.getElementById(id) : null;
      if (!el) return null;
      if (el.classList.contains("ch-section") || el.hasAttribute("data-toc")) return el.id;
      var ch = chapterOf(el);
      if (ch) {
        var first = ch.querySelector(".ch-section[id], [data-toc][id]");
        return first ? first.id : ch.id;
      }
      return el.id;
    }

    var activeId = null;
    function setActive(id) {
      var resolved = resolveActiveId(id);
      if (!resolved || resolved === activeId) {
        /* Still force chapter open when landing on #ch2 even if same section. */
        if (resolved && resolved === activeId) {
          var same = document.getElementById(resolved);
          var sameCh = chapterOf(same);
          if (sameCh) {
            root.querySelectorAll(".ch").forEach(function (c) {
              var match = c.getAttribute("data-ch") === sameCh.id;
              c.classList.toggle("is-current", match);
              c.classList.toggle("is-open", match && !!c.querySelector(".ch__sections"));
            });
          }
        }
        return;
      }
      activeId = resolved;
      links().forEach(function (a) {
        var spy = a.dataset.spy || hashOf(a.getAttribute("href"));
        a.setAttribute("aria-current", spy === resolved ? "true" : "false");
      });
      var sec = document.getElementById(resolved);
      var chEl = chapterOf(sec);
      root.querySelectorAll(".ch").forEach(function (c) {
        var match = !!(chEl && c.getAttribute("data-ch") === chEl.id);
        c.classList.toggle("is-current", match);
        c.classList.toggle("is-open", match && !!c.querySelector(".ch__sections"));
      });
      var label = "";
      if (sec) {
        label = sec.getAttribute("data-toc") || "";
        if (!label) {
          var h = sec.querySelector("h3, h2");
          label = h ? h.textContent.trim() : "";
        }
      }
      var now = gid("subnavNow");
      if (now && label) now.textContent = label;
      var chip = root.querySelector(".subnav__chip");
      var meta = chEl
        ? CHAPTERS.filter(function (c) { return c.id === chEl.id; })[0]
        : null;
      if (chip) chip.textContent = meta ? "CH " + meta.n : "GUIDE";
    }

    function spyMarkerY() {
      var headerH = parseFloat(getComputedStyle(root).getPropertyValue("--header-h")) || 92;
      var extra = window.matchMedia("(min-width: 1000px)").matches ? 28 : 70;
      return headerH + extra;
    }

    /* Last section whose top has crossed the sticky marker — also handles
       chapter titles (#ch2) before the first .ch-section enters view. */
    function updateSpyFromScroll() {
      var marker = spyMarkerY();
      var best = null;
      var bestTop = -Infinity;

      spied.forEach(function (s) {
        var top = s.getBoundingClientRect().top;
        if (top <= marker + 1 && top >= bestTop) {
          best = s;
          bestTop = top;
        }
      });

      CHAPTERS.forEach(function (ch) {
        if (ch.status !== "live" || !ch.id) return;
        var el = document.getElementById(ch.id);
        if (!el) return;
        var top = el.getBoundingClientRect().top;
        var first = el.querySelector(".ch-section[id], [data-toc][id]");
        if (!first) return;
        /* Chapter head is in view / past marker, but first section not yet. */
        if (top <= marker + 1 && first.getBoundingClientRect().top > marker) {
          if (!best || top >= bestTop) {
            best = first;
            bestTop = top;
          }
        }
      });

      if (best) setActive(best.id);
    }

    (function seedActive() {
      var hash = (location.hash || "").replace(/^#/, "");
      if (hash && document.getElementById(hash)) {
        setActive(hash);
        return;
      }
      updateSpyFromScroll();
    })();

    var article = gid("content");
    var bar = gid("progressBar");
    var pct = gid("railPct");

    function onScroll() {
      updateSpyFromScroll();
      if (!article) return;
      var rect = article.getBoundingClientRect();
      var start = window.scrollY + rect.top;
      var h = article.offsetHeight - window.innerHeight;
      var p = Math.min(100, Math.max(0, ((window.scrollY - start) / Math.max(h, 1)) * 100));
      if (bar) bar.style.width = p + "%";
      if (pct) pct.textContent = Math.round(p) + "%";
    }

    document.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    root.addEventListener("click", function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a || !root.contains(a)) return;
      var id = hashOf(a.getAttribute("href"));
      var target = id ? document.getElementById(id) : null;
      if (!target) return;
      e.preventDefault();
      setActive(id);
      var headerH = parseFloat(getComputedStyle(root).getPropertyValue("--header-h")) || 92;
      var extra = window.matchMedia("(min-width: 1000px)").matches ? 26 : 70;
      var y = window.scrollY + target.getBoundingClientRect().top - headerH - extra;
      window.scrollTo({ top: Math.max(0, y), behavior: "smooth" });
      if (history.replaceState) history.replaceState(null, "", "#" + id);
    });

    var subnav = gid("subnav");
    var subnavBtn = gid("subnavBtn");
    if (subnav && subnavBtn) {
      subnavBtn.addEventListener("click", function () {
        var open = subnav.classList.toggle("is-open");
        subnavBtn.setAttribute("aria-expanded", open ? "true" : "false");
      });
      subnav.addEventListener("click", function (e) {
        if (e.target.closest("a")) {
          subnav.classList.remove("is-open");
          subnavBtn.setAttribute("aria-expanded", "false");
        }
      });
    }

    if ("IntersectionObserver" in window) {
      var ro = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add("is-in");
            ro.unobserve(e.target);
          }
        });
      }, { rootMargin: "0px 0px -8% 0px" });
      root.querySelectorAll(".reveal").forEach(function (el) { ro.observe(el); });
    } else {
      root.querySelectorAll(".reveal").forEach(function (el) { el.classList.add("is-in"); });
    }
  });
})();
